import python from "./imgskills/python.png";
import java from "./imgskills/java.png";
import javascript from "./imgskills/javascript.png";
import cpp from "./imgskills/cpp.png";
import c from "./imgskills/c.png";
import php from "./imgskills/php.png";
import sql from "./imgskills/sql.png";
import typescript from "./img/typescript.png"
import react from "./imgskills/reactreact.png"
import spring from "./imgskills/springbit.png"
import kivy from "./imgskills/kivy.png"
import pandas from "./imgskills/panda.png"
import pytorch from "./imgskills/pytorch.png"
import tenser from "./imgskills/tenserr.png"
import open from "./imgskills/open.png"
import micpro from "./imgskills/micpro.png"
import uml from "./imgskills/stauml.png"
import exel from "./imgskills/exell.png"
import word from "./imgskills/Wo.png"
import power from "./imgskills/powerpoint.png"
import mongo from "./imgskills/mongoo.png"
import porst from "./imgskills/porst.png"
import oracle from "./imgskills/oracle.png"
import fire from "./imgskills/fire.png"
import and from "./imgskills/and.png"
import charm from "./imgskills/charm.png"
import jupy from "./imgskills/jupy.png"
import intelijj from "./imgskills/intelijj.png"
import vscode from "./imgskills/vscode.png"
import cisco from "./imgskills/cisco.png"
import fig from "./imgskills/figma.png"
import post from "./imgskills/post.png"
import mat from "./imgskills/m.png"
import ras4 from "./imgskills/ras4.png"
import ard from "./imgskills/ard.png"
import esp from "./imgskills/esp32.png"
import nextjs from "./imgskills/nextjs.png"
import fastapi from "./imgskills/fastapi.png"
import docker from "./imgskills/docker.png"
import actions from "./imgskills/actions.png"
import nginx from "./imgskills/nginx.png"
export const langage = [
  {
    image: python,
    nom: "Python",
    per:75
  },
   {
    image: java,
    nom: "Java",
    per:80
  },
   {
    image: javascript,
    nom: "Javascript",
    per:82
  },
  {
    image: typescript,
    nom: "Typescript",
    per:70
  },
   {
    image: cpp,
    nom: "C++",
    per:50
  },
   {
    image: c,
    nom: "C",
    per:50
  },
   {
    image: mat,
    nom: "Matlab",
    per:50
  },
   {
    image: php,
    nom: "PHP",
    per:40
  },
   
   
  
];
export const framework=[
{
  image:nextjs,
  nom:"Next.js",
  per:60
},
{
  image:react,
  nom:"React.js",
  per:70
},
{
  image:spring,
  nom:"Spring Boot",
  per:75
},
{
  image:fastapi,
  nom:"FastAPI",
  per:65
},

{
  image:kivy,
  nom:"KivyMD",
  per:80
},
{
  image:pandas,
  nom:"Pandas",
  per:60
},
{
  image:pytorch,
  nom:"PyThorch",
  per:55
},
{
  image:tenser,
  nom:"TensorFlow",
  per:65
},
{
  image:open,
  nom:"OpenCV",
  per:70
},

]
export const conception=[
  {
    image:micpro,
    nom:"MS Project",
    per:68
  },
   {
    image:uml,
    nom:"StarUML",
    per:65
  },
]
export const bureatique=[
  {
    image:exel,
    nom:"Excel",
    per:70
  },
  {
    image:word,
    nom:"Word",
    per:80
  },
  {
    image:power,
    nom:"PowerPoint",
    per:80
  },
]
export const base=[
  {
    image:sql,
    nom:"SQL",
    per:80
  },
  {
    image:mongo,
    nom:"MongoDB",
    per:70
  },
  {
    image:porst,
    nom:"PostgreSQL",
    per:80
  },
  {
    image:oracle,
    nom:"Oracle",
    per:60
  },
  {
    image:fire,
    nom:"FireBase",
    per:65
  },
]
export const IDE=[
  {
    image:vscode,
    nom:"VS Code",
    per:80
  },
  {
    image:intelijj,
    nom:"Intellij",
    per:80
  },
  {
    image:and,
    nom:"Android Studio",
    per:50
  },
  {
    image:charm,
    nom:"PyCharm",
    per:60
  },
  {
    image:jupy,
    nom:"Jupyter Notebook",
    per:85
  },
  
  {
    image:cisco,
    nom:"Cisco Packet Tracer",
    per:65
  },
  {
    image:fig,
    nom:"Figma",
    per:75
  },
  
  {
    image:post,
    nom:"Postman",
    per:72
  },
  
  {
    image:mat,
    nom:"Matlab",
    per:60
  },
]
export const carte=[
  {
    image:ras4,
    nom:"Raspberry Pi",
    per:80
  },
   {
    image:ard,
    nom:"Arduino",
    per:70
  },
   
   {
    image:esp,
    nom:"ESP32",
    per:55
  },
]
export const ops=[
  {
    image:docker,
    nom:"Docker",
    per:70
  },
   {
    image:actions,
    nom:"GitHub Actions (CI/CD)",
    per:60
  },
   
   {
    image:nginx,
    nom:"Nginx",
    per:65
  },
]


